import type { MatchDetails } from "./types";

// ==================================================
// MATCH DETAILS 2026/27 — MEN'S DOMESTIC
// INVESTEC CHAMPIONS CUP
// ==================================================

export const matchDetailsInvestec: MatchDetails[] = [
  {
    matchKey: "gloucester-vs-bordeaux-begles-investec",
    highlightsUrl: "https://www.youtube.com/watch?v=duSrL7wTogQ",
    timeline: [
      { minute: "0'", label: "Kick-off — Kingsholm Stadium, Gloucester" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "Kingsholm Stadium", value: "Gloucester" },
    ],
  },
  {
    matchKey: "sale-vs-glasgow-investec",
    highlightsUrl: "https://www.youtube.com/watch?v=wvKxWbgRcAc",
    timeline: [
      { minute: "0'", label: "Kick-off — CorpAcq Stadium, Salford" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "CorpAcq Stadium", value: "Salford" },
    ],
  },
  {
    matchKey: "bulls-vs-stade-francais-investec",
    highlightsUrl: "https://www.youtube.com/watch?v=yga00uKwenw",
    timeline: [
      { minute: "0'", label: "Kick-off — Loftus Versfeld, Pretoria" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "Loftus Versfeld", value: "Pretoria" },
    ],
  },
  {
    matchKey: "clermont-vs-leinster-investec",
    highlightsUrl: "https://www.youtube.com/watch?v=T7sH3LBlrwk",
    timeline: [
      { minute: "0'", label: "Kick-off — Stade Marcel-Michelin, Clermont-Ferrand" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      {
        category: "Venue",
        player: "Stade Marcel-Michelin",
        value: "Clermont-Ferrand",
      },
    ],
  },
  {
    matchKey: "stormers-vs-bristol-investec",
    highlightsUrl: "https://www.youtube.com/watch?v=ZB2gkZlSDiM",
    timeline: [
      { minute: "0'", label: "Kick-off — DHL Stadium, Cape Town" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "DHL Stadium", value: "Cape Town" },
    ],
  },
  {
    matchKey: "connacht-vs-saracens-investec",
    highlightsUrl: "https://www.youtube.com/watch?v=Lb7-NU5fvGc",
    timeline: [
      { minute: "0'", label: "Kick-off — Dexcom Stadium, Galway" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "Dexcom Stadium", value: "Galway" },
    ],
  },
  {
    matchKey: "la-rochelle-vs-lions-investec",
    highlightsUrl: "https://www.youtube.com/watch?v=fUEp-KURar8",
    timeline: [
      { minute: "0'", label: "Kick-off — Stade Marcel Deflandre, La Rochelle" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      {
        category: "Venue",
        player: "Stade Marcel Deflandre",
        value: "La Rochelle",
      },
    ],
  },
  {
    matchKey: "munster-vs-racing-92-investec",
    highlightsUrl: "https://www.youtube.com/watch?v=ZBJN1-KBDq8",
    timeline: [
      { minute: "0'", label: "Kick-off — SuperValu Páirc Uí Chaoimh, Cork" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      {
        category: "Venue",
        player: "SuperValu Páirc Uí Chaoimh",
        value: "Cork",
      },
    ],
  },
  {
    matchKey: "bath-vs-montpellier-investec",
    highlightsUrl: "https://www.youtube.com/watch?v=CAilYQpDIsM",
    timeline: [
      { minute: "0'", label: "Kick-off — The Rec, Bath" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "The Rec", value: "Bath" },
    ],
  },
  {
    matchKey: "pau-vs-leicester-investec",
    highlightsUrl: "https://www.youtube.com/watch?v=uWfXiXADzsI",
    timeline: [
      { minute: "0'", label: "Kick-off — Stade du Hameau, Pau" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "Stade du Hameau", value: "Pau" },
    ],
  },
  {
    matchKey: "toulouse-vs-exeter-investec",
    highlightsUrl: "https://www.youtube.com/watch?v=wgoUKxsGRj8",
    timeline: [
      { minute: "0'", label: "Kick-off — Stadium de Toulouse, Toulouse" },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      { category: "Venue", player: "Stadium de Toulouse", value: "Toulouse" },
    ],
  },
  {
    matchKey: "northampton-vs-cardiff-investec",
    highlightsUrl: "https://www.youtube.com/watch?v=dZ5oiunc71g",
    timeline: [
      {
        minute: "0'",
        label: "Kick-off — DPD Stadium at Franklin's Gardens, Northampton",
      },
      { minute: "40'", label: "Half Time" },
      { minute: "80'", label: "Full Time" },
    ],
    performances: [
      {
        category: "Venue",
        player: "Franklin's Gardens",
        value: "Northampton",
      },
    ],
  },
];